



























import Colorable from '@/mixins/colorable';
import Themeable from '@/mixins/themeable';
import mixins from '@/utils/mixins';

import { PropValidator } from 'vue/types/options';
const baseMixins = mixins(Colorable, Themeable);

export default baseMixins.extend({
  name: 'Messages',
  props: {
    value: {
      type: Array,
      default: () => []
    } as PropValidator<string[]>
  }
});
